import React from 'react';
import { TouchableOpacity, TouchableOpacityProps } from 'react-native';
import Text from '../../common/component/CustomTextComponent';

interface ITouchableTextProps extends TouchableOpacityProps{
    text:string;
    style?:any;
    textStyles?:any;
    typeOfSix?:"one_six"|"two_six"|"three_six"|"four_six"|"five_six"|"six_six";
    fontSize?:"x-small"|"small"|"medium"|"large"|"x-large";
}

const TouchableText = (props:ITouchableTextProps)=>{
    
    const { onPress, text, style, textStyles, typeOfSix, fontSize } = props;

    const customStyle = !!style ? (Array.isArray(style) ? style : [style]) : [];
    const customTextStyles = !!textStyles ? (Array.isArray(textStyles) ? textStyles : [textStyles]) : [];
    const type_of_six = typeOfSix ?? "three_six";
    const font_size = fontSize ?? "medium";

    return (
        <TouchableOpacity style={[...customStyle]} onPress={onPress}>
            <Text fontSize={font_size} style={[...customTextStyles]} type_of_six={type_of_six} fontFamily={'FuturaPTMedium'}>{text}</Text>
        </TouchableOpacity>
    )
}

export default TouchableText;